import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { temaAbone, temaBaslat } from "@kantin/ui";

import "@fontsource-variable/hanken-grotesk";
import "@fontsource-variable/fraunces";
import "@fontsource-variable/jetbrains-mono";
import { Uygulama } from "./Uygulama.js";
import "./stiller.css";

temaBaslat("kantin.platform.tema");

// Ortak tema seçicisinin durum çubuğunu platformun kendi yüzeyiyle eşleştir.
function temaRenginiEsle() {
  const etiket = document.querySelector<HTMLMetaElement>(
    "meta[data-tema-rengi]",
  );
  if (etiket) etiket.content = getComputedStyle(document.body).backgroundColor;
}
temaRenginiEsle();
const temaAboneliginiKapat = temaAbone(temaRenginiEsle);
if (import.meta.hot) import.meta.hot.dispose(temaAboneliginiKapat);

createRoot(document.getElementById("kok")!).render(
  <StrictMode>
    <Uygulama />
  </StrictMode>,
);
